(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mapbox-map-tool", [], factory);
	else if(typeof exports === 'object')
		exports["mapbox-map-tool"] = factory();
	else
		root["mapbox-map-tool"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition